angular.module('impactx.rfx').controller('RFXChangeItemCtrl', RFXChangeItemCtrl);

RFXChangeItemCtrl.$inject = [
    '$scope',
    'dataGen',
    'TranslationService',
    'themeFactory',
    '$redirect',
    '$routeParams',
    'ToastService',
    '$mdDialog',
    'headerLabel',
    'item',
    'rfqsId',
    'trns',
    'RFXSupplierService',
    'AppConfiguration',
    'allowEditProduct'
];

function RFXChangeItemCtrl($scope, dataGen, TranslationService, themeFactory, $redirect, $routeParams, ToastService, $mdDialog,
                           headerLabel, item, rfqsId, trns, RFXSupplierService, AppConfiguration, allowEditProduct) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("accept");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.noSelectedItemMessageLabel = TranslationService.get("noSelectedItemMessage");
    $scope.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');
    $scope.theme = themeFactory.getTheme();

    $scope.headerLabel = headerLabel;
    $scope.item = item;
    $scope.rfqsId = rfqsId;
    $scope.trns = trns;
    $scope.readOnlyProduct = (item.productId > 0 && !allowEditProduct);

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.accept = function () {
        RFXSupplierService.updateItem($scope.item, $scope.rfqsId).then(function (data) {
            $mdDialog.hide(data);
        });
    };
}